import * as r from "react";
import "react/jsx-runtime";
function t() {
  let e = !1;
  return {
    clearReset: () => {
      e = !1;
    },
    reset: () => {
      e = !0;
    },
    isReset: () => e
  };
}
var s = r.createContext(t()), o = () => r.useContext(s);
export {
  o as useQueryErrorResetBoundary
};
//# sourceMappingURL=contact-channels113.js.map
